/*
* Mobile product gallery carousel
*
* Starts Flickity on .product-main-carousel below the theme's mobile breakpoint.
* Desktop keeps the theme's own gallery (product-images.js), so the carousel is
* destroyed again when the viewport grows past the breakpoint.
*/

(function () {
  const selectors = {
    carousel: '.product-main-carousel',
    cell: '.carousel-cell:not(.media--variant-hidden)',
    productImages: 'product-images',
  };

  const classes = {
    active: 'media--active',
    dragging: 'is-dragging',
  };

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const instances = new WeakMap();

  function getFlickity() {
    // Theme's bundled Flickity (v3) renders the .flickity-page-dot markup that product.css styles
    return (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
  }

  function create(carousel) {
    const Flickity = getFlickity();
    const cells = Array.from(carousel.querySelectorAll(selectors.cell));
    const productImages = carousel.closest(selectors.productImages);

    if (!Flickity || cells.length < 2) return;

    const activeIndex = cells.findIndex((cell) => cell.classList.contains(classes.active));

    const flkty = new Flickity(carousel, {
      cellSelector: selectors.cell,
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      initialIndex: activeIndex > -1 ? activeIndex : 0,
    });

    // zoom.js skips the click when product-images is dragging, so a swipe never opens the zoom
    flkty.on('dragStart', () => productImages?.classList.add(classes.dragging));
    flkty.on('dragEnd', () => setTimeout(() => productImages?.classList.remove(classes.dragging), 0));

    // Variant change: the theme fires theme:media:select with the variant's media id
    const onMediaSelect = (event) => {
      const index = cells.findIndex((cell) => cell.dataset.mediaId === event.detail?.id);
      if (index > -1) flkty.select(index);
    };
    productImages?.addEventListener('theme:media:select', onMediaSelect);

    instances.set(carousel, { flkty, productImages, onMediaSelect });
  }

  function destroy(carousel) {
    const instance = instances.get(carousel);
    if (!instance) return;

    instance.productImages?.removeEventListener('theme:media:select', instance.onMediaSelect);
    instance.productImages?.classList.remove(classes.dragging);
    instance.flkty.destroy();
    instances.delete(carousel);
  }

  function toggle() {
    document.querySelectorAll(selectors.carousel).forEach((carousel) => {
      if (mobileQuery.matches) {
        if (!instances.has(carousel)) create(carousel);
      } else {
        destroy(carousel);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toggle);
  } else {
    toggle();
  }

  mobileQuery.addEventListener('change', toggle);

  document.addEventListener('theme:variant-media:before-update', (event) => {
    const carousel = event.target.querySelector(selectors.carousel);
    if (carousel) destroy(carousel);
  });
  document.addEventListener('theme:variant-media:update', toggle);
  document.addEventListener('shopify:section:load', toggle);
})();
